import styled from "styled-components";
import titre from '../assets/img/Titrejaune1.png';

const HeaderLink = styled.a`
    text-decoration: none;
    color: var(--secondary-text-color);
    transition: ease-in 0.1s;
    &:hover {
        color: var(--main-color);
        font-weight: bold;
    }
    color: ${props => props.selected ? "var(--main-color)" : "var(--secondary-text-color)"};
    font-size:1.3em;
`;

const Icon = styled.img`
    width: 5em;
    padding: 1em;
    transition: transform 350ms ease-in-out;
    &:hover {
        transform: translateY(-10px);   
    }
`;

const Title = styled.h1`
    font-size: 2.5em;
    color: var(--main-color);
    background-image: url(${titre});
    background-size: 100%;
    padding: 0.2em;
    background-repeat: no-repeat;
    display: inline-block;
    background-size: 100% 100%;
    min-width: 8em;
`;

export { Icon, HeaderLink, Title };


// WEBPACK FOOTER //
// ./src/components/MiniComponents.jsx